import { FuseboxState } from "@shared/types";
import { Page } from "../enums/Page";
import { css, html } from "../helpers/webComponents";
import { FuseboxService } from "../services/FuseboxService";
import { GameEventService } from "../services/GameEventService";

const styles: string = css`
    :host {
        display: inline-block;
        font-family: "Seven Segment", monospace;
        margin-top: 20rem;
    }

    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
    }

    .input-containerMatch {
        background: #1b1b1b;
        border: 2px solid #777;
        padding: 5px;
        margin: 0px;
        border-radius: 5px;
        text-align: center;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
    }

    p {
        /* width: 80px; */
        /* height: 60px; */
        margin: 0px;
        font-size: 22px;
        font-weight: bold;
        background: transparent;
        color: #2bff00;
        border: none;
        text-align: center;
        outline: none;
        pointer-events: none;
    }

    button {
        color: #2bff00;
        background: #1b1b1b;
        border: 2px solid #777;
        padding: 5px;
        border-radius: 5px;
        text-align: center;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
    }

    .input-container {
        background: #1b1b1b;
        border: 2px solid #777;
        padding: 5px;
        border-radius: 5px;
        text-align: center;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
    }

    #numpadInput {
        width: 180px;
        height: 40px;
        font-size: 22px;
        font-weight: bold;
        background: transparent;
        color: #2bff00;
        border: none;
        text-align: center;
        outline: none;
        pointer-events: none;
    }

    .numpad {
        display: grid;
        grid-template-columns: repeat(3, 78px);
        gap: 5px;
        background: radial-gradient(circle, #3a3a3a 0%, #1b1b1b 100%);
        padding: 15px;
        border-radius: 10px;
        border: 2px solid #777;
        box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5), 0 4px 8px rgba(0, 0, 0, 0.3);
        max-width: 200px;
        text-align: center;
    }

    .switch {
    position: relative;
    display: inline-block;
    width: 34px;
    height: 60px;
    }

    .switch input { 
    opacity: 0;
    width: 0;
    height: 0;
    }

    .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #8b8b8b;
    -webkit-transition: .4s;
    transition: .4s;
    /* border-radius: 34px; */
    }

    .slider:before {
    position: absolute;
    content: "";
    height: 10px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: #c70303;
    -webkit-transition: .4s;
    transition: .4s;
    /* border-radius: 50%; */
    }

    input[type="text"] {
        font-family: "Seven Segment", monospace;
    }

    input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
    }

    input:checked {
        background-color: green;
    }

    input:checked + .slider:before {
    -webkit-transform: translateY(-26px);
    -ms-transform: translateY(-26px);
    transform: translateY(-42px);
    }
`;

export class FuseboxComponent extends HTMLElement {
    private readonly _gameEventService: GameEventService = new GameEventService();
    private readonly _fuseboxService: FuseboxService = new FuseboxService();
    // private buttons?: NodeListOf<HTMLButtonElement>;
    private _switches?: NodeListOf<HTMLInputElement>;

    public constructor() {
        super();
    }

    public connectedCallback(): void {
        // Attach a shadow the the component for scoped styling
        this.attachShadow({ mode: "open" });
        // Render the body of the component
        void this.refreshState();
    }

    private async refreshState(): Promise<void> {
        const state: FuseboxState = await this._fuseboxService.getState();
        this.render(state);
    }

    private render(state: FuseboxState): void {
        // Only run the render method if the shadow root is attached
        if (!this.shadowRoot) return;
        // Construct the body of the element
        const body: HTMLElement = this.construct(state);
        // Replace the current body
        this.shadowRoot.replaceChildren(body);
    }

    public construct(state: FuseboxState): HTMLElement {
        // HTML en CSS binnen de shadow DOM
        const element: HTMLElement = html`
        <div>
            <style>
                ${styles}
            </style>

            <div class="container">
                <div class="intructions">
                    <p>Match the voltage</p>
                </div>
                <div class="input-containerMatch">
                    <p id="answer">${state.answer}V</p>
                </div>
                <div class="input-container">
                    <input type="text" id="numpadInput" value="${state.totalVoltage}V" readonly>
                </div>
                <div class="numpad">
                    ${state.switchStates.map(switchState => `
                        <label class="switch">
                            <input type="checkbox" ${switchState ? "checked" : ""} >
                            <span class="slider"></span>
                        </label>
                    `).join("")}
                </div>
                <button id="close">close</button>
            </div>
        </div>
            
        `;

        element.querySelector<HTMLButtonElement>("#close")?.addEventListener("click", () => this._gameEventService.switchPage(Page.Canvas));

        // Alle switches ophalen
        this._switches = element.querySelectorAll(".switch input")!;

        this._switches.forEach((switchInput: HTMLInputElement, index: number) => {
            switchInput.addEventListener("change", async () => {
                await this._fuseboxService.toggleSwitch(index).then(state => {
                    if (state.correct) this._gameEventService.switchPage(Page.Canvas);
                    else this.render(state);
                });
            });
        });
        return element;
    }
}
